<style scoped lang="scss">
    @import "../../../common/styles/var";

    dt {
        padding-bottom: 10px;
        font-size: 15px;
        text-align: center;
    }

    dd + dd {
        margin-top: 5px;
    }

    dd {
        font-size: 12px;
        color: #666;

        span {
            padding: 0 5px;
            border-radius: 4px;
            display: inline-block;
            border: 1px solid $mainColor;
        }
    }

    li {
        width: (100%/7);
    }

    ol {
        li {
            text-align: center;
        }
    }

    ul {
        li {
            background-color: #fcfcfc;
            height: 85px;
            float: left;

            &.isCurrMonth {
                background-color: #ffffff;
            }

            &.yiman {
                background-color: #f8f8f8;
            }

            &[status='暂无'] {
                background-color: #f8f8f8;

                .number {
                    display: none;
                }
            }

            &[status='已逾期'] {
                background-color: #f8f8f8;

                .number {
                    display: none;
                }
            }

            &[status='缺医技'] {
                .number {
                    color: red;
                }
            }


            .day {
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
            }

            .number {
                text-align: center;
                left: 0;
                right: 0;
                bottom: 5px;
            }
        }
    }
</style>
<template>
    <div>
        <el-dialog append-to-body :visible.sync="showTag" width="80%" title="团队体检预约">
            <div class="flex" style="margin-top: -20px">
                <div class="info flex0" style="width: 40%">
                    <h3>{{info.healthcheckerName}} {{info.healthcheckerGender}} {{info.healthcheckerAge}}岁</h3>
                    <div class="mt10">
                        <p>身份证：{{info.healthcheckerIdcard}}</p>
                        <p>手机号：{{info.healthcheckMobile}}</p>
                        <p>体检时间范围：{{info.appointmentTimeInterval}}</p>
                        <p>预约日期：{{info.appointmentDate|date}}</p>
                    </div>

                    <h3 class="mt10">{{info._comboName}} 套餐详情</h3>

                    <dl v-for="(item,index) in list" :key="index" class="bt pt5 pb5">
                        <dt>{{index}}</dt>
                        <dd v-for="(data,idx) in item" :key="'dd'+idx">
                            <span class="color_main">{{data.combinationItemName}}</span>
                        </dd>
                    </dl>

                </div>
                <div class="rili flex1 ml10">
                    <h3>可预约日期</h3>
                    <div class="mt10">
                        <div class="flex aic">
                            <span class="pointer flex0 el-icon-caret-left color_main" @click="handler('-')"></span>
                            <p class="flex1" style="text-align: center">{{currYear}}年{{currMonth}}月</p>
                            <span class="pointer flex0 el-icon-caret-right color_main" @click="handler('+')"></span>
                        </div>
                        <ol class="flex pt5 pb5 bt">
                            <li v-for="(item,index) in week" :key="'ol'+index">星期{{item}}</li>
                        </ol>
                        <ul class="oh bt bb bl br">
                            <li :status="getText(item)" @click="doYuyue(item)" v-for="(item,index) in range"
                                :key="'li'+index"
                                class="relative pointer"
                                :class="[index%7>0?'bl':'',index>6?'bt':'',item.isCurrMonth?'isCurrMonth':'',item.numberSourceBookedStatus==='BE_OVERDUE'?'yiman':'']">
                                <template v-if="item.isCurrMonth">
                                    <div class="absolute day flex aic jcc fs16">{{item.day}}</div>
                                    <div class="absolute number">{{getText(item)}}</div>
                                </template>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </el-dialog>
        <dialog-number ref="num" @yuyue="sub"></dialog-number>
        <dialog-error ref="error"></dialog-error>
    </div>
</template>

<script>
  import {DiaLogMixin} from "../../../common/lib/mixins/dialog-base";
  import {timeFilter} from "../../../common/lib/filters";
  import {healthcheckService} from "../services/healthcheck";
  import {RiliMixin} from "../mixin";
  import dayjs from 'dayjs';
  import DialogNumber from "./dialog-number";
  import DialogError from "./dialog-error";

  export default {
    name: "dialog-tj-yuyue2",
    components: {DialogError, DialogNumber},
    filters: {
      date(str) {
        if (!str) return "暂未确定，请尽快预约具体日期";
        else return timeFilter(str, "YYYY-MM-DD");
      }
    },
    mixins: [DiaLogMixin, RiliMixin],
    data() {
      return {
        info: {},
        list: {},
        data: []
      }
    },
    computed: {
      range() {
        let {start, end, curr, data} = this;
        let s = start.valueOf(), e = end.valueOf();
        let arr = [];
        let dataArr = [...data];
        while (s <= e) {
          let day = dayjs(s);
          let date = day.format('YYYY-MM-DD');
          const d = dataArr.shift();
          arr.push({
            date,
            ...d,
            day: day.format('DD'),
            month: day.month(),
            isCurrMonth: day.month() === dayjs(curr).month()
          });
          s += 24 * 3600 * 1000;
        }
        return arr;
      }
    },
    methods: {
      open(data) {
        this.show();
        this.info = data;
        this.getData();
      },
      handler(type) {
        this.handlerRili(type);
        this.getData();
      },

      getText(data) {
        const {numberSourceBookedStatus, numberSourceTotal = '', surplusNumberSourceTotal = ''} = data;
        if (numberSourceBookedStatus === "BE_OVERDUE") {
          return "已逾期";
        } else if (numberSourceBookedStatus === "LACK_MEDICAL_SKILLS") {
          return "缺医技";
        } else if (numberSourceTotal) return `${surplusNumberSourceTotal}/${numberSourceTotal}`;
        else if (numberSourceBookedStatus === 'NO_NUMBER_SOURCE') return '暂无';
      },

      doYuyue(data) {
        if (["LACK_MEDICAL_SKILLS", "NO_NUMBER_SOURCE"].includes(data.numberSourceBookedStatus)) this.$refs.error.open(data.numberSourceBookedStatus, data.lackMedicalSkillsComboItemList);

        if (data.numberSourceBookedStatus !== 'NORMAL') return;
        this.curr = data.date;
        this.$refs.num.open(data.date);
      },

      async sub(data) {
        const {info} = this;
        const date = dayjs(this.curr).format('YYYY-MM-DD');
        let {code, list} = await healthcheckService.tjPreBook({
          healthcheckOrderId: info.platOrderId,
          startTime: date,
          endTime: date,
          healthcheckTeamId: this.healthcheckBookTeam.platTeamId
        });
        if (code !== '0') {
          return;
        }

        if (!list || !list.length) return;

        const {numberSourceBookedStatus: status, lackMedicalSkillsComboItemList} = list[0] || {};
        if (status !== 'NORMAL') {
          return this.$emit('error', status, lackMedicalSkillsComboItemList);
        }


        const {code: c} = await healthcheckService.tjPlatOrderBook({
          healthcheckOrderId: info.platOrderId,
          numberSourceId: data.numberSourceId,
          timeIntervalId: data.timeIntervalId,
          comboName: info._comboName || undefined
        });

        if (c === '0') {
          this.$message.success('预约成功');
          this.$emit('ok', 1);
          this.hide();
        }

      },


      async getData() {
        const {info} = this;
        const {list} = await healthcheckService.tjPreBook({
          healthcheckOrderId: info.platOrderId,
          healthcheckTeamId: this.healthcheckBookTeam.platTeamId,
          startTime: dayjs(this.start).format('YYYY-MM-DD'),
          endTime: dayjs(this.end).format('YYYY-MM-DD')
        });
        const {healthcheckTeamComboItemList} = await healthcheckService.teamOrderDetail(info.platOrderId);
        this.list = healthcheckTeamComboItemList || {};
        this.data = list || [];
      }
    },
  }
</script>

